import { combine, withCallbacks, withContext } from 'react-hooks-combine'
import { withFormModel } from 'shared/hooks'
import { ServicesContext } from 'services/context'
import { spec, validators } from 'utils/validation'

import { toOptions } from 'routes/public/events/overview/components/filters/helpers'
import i18next from 'i18next'
import { StoreContext } from 'store/context'
import EditTeamsFormComponent from './component'
import { createFormatSportFunction } from './helpers'
import { toTeamModel } from './mapping'

const { any } = validators

export const EditTeamsForm = combine(
  withContext(
    'adminTeamsService',
    ServicesContext,
    ({ adminTeamsService }) => adminTeamsService
  ),
  withContext('appStore', StoreContext),

  withFormModel(
    (_state, { initialValues }) => {
      return {
        teamName: {
          initialValue: initialValues.teamName || '',
          spec: spec.flow(any.required),
        },

        teamWebsite: {
          initialValue: initialValues.teamWebsite || '',
          spec: spec.flow(any.required),
        },

        jurisdiction: {
          initialValue: initialValues.jurisdiction || '',
          spec: spec.flow(any.required),
        },

        sport: {
          initialValue: createFormatSportFunction(initialValues.sport) || '',
          spec: spec.flow(any.required),
        },

        logo: {
          initialValue: initialValues.logo,
          spec: spec.flow(),
        },
        id: {
          initialValue: initialValues.id || '',
          spec: spec.flow(any.required),
        },
      }
    },
    { id: 'team-edit-form' }
  ),

  withCallbacks(
    {
      loadCategories: () => async () => {
        const sportTypes = toOptions(
          i18next.t('enum:sportType', { returnObjects: true })
        )
        return sportTypes
      },
      loadJurisdictionList:
        ({ appStore }) =>
        async () => {
          const jurisdictions =
            await appStore.adminTeams.loadJurisdictionListFromStore()
          return jurisdictions.jurisdictions
        },
      onSubmitRequest: {
        deps: ['onSubmit'],
        func:
          (_state, { onSubmit }) =>
          (form) => {
            return onSubmit(toTeamModel(form))
          },
      },
    },
    []
  )
)(EditTeamsFormComponent)
